<script lang="ts">
  import { onMount } from "svelte";

  import Window from "../components/Window.svelte";
  import SettingsMgr from "../stores/SettingsMgr";
  import type { Theme, WinCbs, WinProps } from "../scripts/WinTypes";
  import { addLog } from "../stores/LoggerStore";
  export let winProps: WinProps;

  //Bindings ==========================================================
  let contElem: HTMLElement, ccElem: HTMLElement, theElem: HTMLCanvasElement;
  let offsetWidth, offsetHeight, innerWidth, innerHeight;
  let ctx; //init on mount

  //Theme ============================================================
  const _theme = SettingsMgr.getInstance().theme;
  const themeWatcher = (theme: Theme) => {
    if (!contElem) {
      return;
    }
    const c = theme.colors;
    contElem.style.setProperty("color", c["1"]);
    contElem.style.setProperty("background-color", c["2"]);
    return theme.colors;
  };
  $: _coloxrs = themeWatcher($_theme);
  //Props======================================================
  const setWinProps = () => {
    winProps.name = winProps.name || "Jamchinko";

    if (!winProps.data) {
      winProps.data = {};
    }
    winProps["data"]["rect"] = winProps.data?.rect || {
      top: "0%",
      left: "0%",
      width: "60%",
      height: "60%",
    };
  };
  setWinProps();
  //Window callbacks================================================

  const callbacks: WinCbs = {
    // onFocus: handleFocus,
    onMaximizeStart: () => {
      if (!theElem) {
        return false;
      }
      theElem.width = 0;
      theElem.height = 0;
      return true;
    },
    onMaximizeFinish: () => {
      if (!theElem) {
        return false;
      }
      setCanvasSize();
      return true;
    },
    // closeWindow: setCloseWindow,
    // maximizeWindow: setMaximizeWindow,
  };
  // winProps["maximizeOnMount"] = true;

  class Root {
    speedX;
    speedY;
    maxSize;
    size;
    angle;
    color;
    constructor(public x, public y, public elem = theElem) {
      this.speedX = Math.random() * 4 - 2;
      this.speedY = Math.random() * 4 - 2;
      this.maxSize = Math.random() * 7 + 5;
      this.size = Math.random() * 1 + 2;
      this.angle = Math.random() * 6.28;
      this.color = Math.random() * 360;
    }
    update() {
      this.x += this.speedX + Math.sin(this.angle);
      this.y += this.speedY + Math.sin(this.angle);
      this.size += 0.1;
      this.angle += 0.2;
      this.color += 10;
      if (this.size < this.maxSize) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `hsl(${this.color},100%,50%)`;
        ctx.fill();
        ctx.stroke(); //border. if stroke style not declared, default is black
        requestAnimationFrame(this.update.bind(this));
      }
    }
  }

  const setup = () => {
    if (!theElem) {
      throw new Error("dd");
    }
  };
  const handleMove = (e) => {
    const x = e.offsetX;
    const y = e.offsetY;
    // console.log(`x ${x}  y ${y}`);
    const root = new Root(x, y);
    root.update();
  };
  const setCanvasSize = () => {
    if (!contElem) {
      return;
    }
    theElem.width = contElem.offsetWidth;
    theElem.height = contElem.offsetHeight;
  };
  onMount(() => {
    ctx = theElem.getContext("2d");
    setCanvasSize();
    setup();
  });
</script>

<svelte:window bind:innerWidth bind:innerHeight />

<Window {winProps} {callbacks}>
  <div class="container" bind:this={contElem}>
    <!-- <div class="canvas-container" bind:this={ccElem}> -->
    <canvas class="the-canvas" on:mousemove={handleMove} bind:this={theElem} />
    <!-- </div> -->
    <div class="css-keeper" />
  </div></Window
>

<style>
  .container {
    position: relative;
    display: block;
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
  }
  .the-canvas {
    position: absolute;
    top: 0;
    left: 0;
    /* width: 100%; */
    /* height: 100%; */
  }
</style>
